import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService } from './service/auth/auth.service';
import { RouterGuardService } from './guard/router-guard/router-guard.service';
import { ConstantService } from './constant/constant.service';
import { PartnerService } from './service/partner/partner.service';
import { SpinnerComponent } from './spinner/spinner.component';
import { LoanService } from './service/loan/loan.service';
import { RangePipe } from './pipe/pipe/range.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {LoanApplicationPartnerResolverService} from './resolver/loanApplicationPartnerResolver/loan-application-partner-resolver.service';
import {StateTransitionsService} from './helper/stateTransitions/state-transitions.service';
import {ReplacePipe} from './pipe/pipe/replace.pipe';
import { RouteChangeMonitorPopupComponent } from './route-change-monitor-popup/route-change-monitor-popup.component';
import {BypassRouteChangeService} from './bypass-route-change/bypass-route-change.service';
import { PaginationComponent } from './common-component/pagination/pagination.component';
import { AuthorizationComponent } from './common-component/authorization/authorization.component';
import { getDatePipe } from './pipe/pipe/getDate.pipe';
import { AdvanceInputComponent } from './common-component/advanceInput/advanceInput.component';
import { PivotDataOpPipe } from './pipe/pipe/pivotDataOp.pipe';
import { getNumFormatPipe } from './pipe/pipe/getNumFormat.pipe';
import { MultiSelectDorpdownComponent } from './common-component/multiselectdorpdown/multiselectdorpdown.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule],
    declarations: [
        SpinnerComponent, 
        RangePipe, 
        ReplacePipe, 
        getDatePipe,
        PivotDataOpPipe,
        getNumFormatPipe,
        RouteChangeMonitorPopupComponent,
        AdvanceInputComponent,
        MultiSelectDorpdownComponent,
        PaginationComponent,
        AuthorizationComponent
    ],
    exports: [
        SpinnerComponent, 
        RangePipe, 
        ReplacePipe, 
        getDatePipe,
        PivotDataOpPipe,
        getNumFormatPipe,
        RouteChangeMonitorPopupComponent,
        AdvanceInputComponent,
        MultiSelectDorpdownComponent,
        PaginationComponent,
        AuthorizationComponent
    ],
    providers: [
        AuthService,
        RouterGuardService,
        ConstantService,
        PartnerService,
        LoanService,
        LoanApplicationPartnerResolverService,
        StateTransitionsService,
        BypassRouteChangeService
    ]
})
export class SharedComponentModule {

}
